
import React from 'react';
import { EyeIcon, ShareIcon } from '../../Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../firebase/firebaseConfig';

interface PropertyCardFooterProps {
  onView: () => void;
  onShare: () => void;
  isMarketInactive: boolean;
}

export const PropertyCardFooter: React.FC<PropertyCardFooterProps> = ({ onView, onShare, isMarketInactive }) => {
  return (
    <div className="mt-auto flex items-stretch gap-2 pt-2 border-t border-gray-100">
      <button 
        onClick={(e) => { e.stopPropagation(); onView(); }} 
        className="flex-grow px-4 py-2 bg-sky-600 text-white text-xs font-bold rounded-lg flex items-center justify-center gap-2" 
        style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
      >
        <EyeIcon className="w-4 h-4" />Ver Detalle
      </button>
      <button 
        onClick={(e) => { e.stopPropagation(); onShare(); }} 
        disabled={isMarketInactive} 
        className="px-3 py-2 border border-gray-300 text-gray-600 rounded-lg disabled:opacity-50"
      >
        <ShareIcon className="w-4 h-4" />
      </button>
    </div>
  );
};
